import type { VendaGateway, ListVendasParams } from '@/application/port/out/VendaGateway';
import type { Venda, VendaParcela, VendaDesconto, CancelarVendaCommand } from '@/domain/model/Venda';
import type { Page } from '@/domain/model/Page';
import type {
  ListVendasUseCase, GetVendaUseCase, ListVendaParcelasUseCase,
  ListVendaDescontosUseCase, CancelarVendaUseCase,
} from '@/application/port/in/VendaUseCase';

export class ListVendas implements ListVendasUseCase {
  constructor(private readonly gateway: VendaGateway) {}
  execute(params: ListVendasParams): Promise<Page<Venda>> { return this.gateway.list(params); }
}
export class GetVenda implements GetVendaUseCase {
  constructor(private readonly gateway: VendaGateway) {}
  execute(id: string): Promise<Venda> { return this.gateway.get(id); }
}
export class ListVendaParcelas implements ListVendaParcelasUseCase {
  constructor(private readonly gateway: VendaGateway) {}
  execute(vendaId: string): Promise<VendaParcela[]> { return this.gateway.listParcelas(vendaId); }
}
export class ListVendaDescontos implements ListVendaDescontosUseCase {
  constructor(private readonly gateway: VendaGateway) {}
  execute(vendaId: string): Promise<VendaDesconto[]> { return this.gateway.listDescontos(vendaId); }
}
export class CancelarVenda implements CancelarVendaUseCase {
  constructor(private readonly gateway: VendaGateway) {}
  execute(id: string, command: CancelarVendaCommand): Promise<Venda> { return this.gateway.cancelar(id, command); }
}
